import { RUN_DB_CLIENTS_SCORING } from '../types/runDbClientsScoringTypes';
import { GET_LAST_SCORING_LOGS } from '../types/getLastScoringLogsTypes';
import createAsyncActions from '../../../utilities/createAsyncActions';

export const {
  runDbClientsScoring,
  runDbClientsScoringPending,
  runDbClientsScoringFulfilled,
  runDbClientsScoringRejected,
} = createAsyncActions(RUN_DB_CLIENTS_SCORING, 'runDbClientsScoring');

export const {
  getLastScoringLogs,
  getLastScoringLogsPending,
  getLastScoringLogsFulfilled,
  getLastScoringLogsRejected,
} = createAsyncActions(GET_LAST_SCORING_LOGS, 'getLastScoringLogs');


// WEBPACK FOOTER //
// ./src/features/score-card/actions/runDbClientsScoringActions.js